module.exports = __webpack_public_path__ + "media/packs/images/no-notification-8b63608c22fab85c3ebcdd82cadd67ee.svg";